import React from 'react';
import { Bell, User, Menu, LogOut } from 'lucide-react';
import { LANGUAGES } from '../mock/mock';
import { toast } from 'sonner';
import useEditorStore from '../store/useEditorStore';
import { useAuth } from '../hooks/useAuth';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_neon-builder-pro/artifacts/5t0ljgml_Enseignes3D-blanc-1024x199.png';

export default function Header() {
  const toggleSidebar = useEditorStore((s) => s.toggleSidebar);
  const { user, loading, login, logout } = useAuth();
  const isAuthed = !!user;

  return (
    <header className="app-header">
      <button
        className="header-burger"
        onClick={toggleSidebar}
        aria-label="Ouvrir le menu"
        title="Configurateur"
        data-testid="sidebar-toggle"
      >
        <Menu size={20} />
      </button>
      <div className="app-logo">
        <img
          src={LOGO_URL}
          alt="Enseignes3D.fr"
          style={{
            height: 46,
            width: 'auto',
            maxWidth: 280,
            objectFit: 'contain',
            filter: 'drop-shadow(0 0 16px rgba(236,29,140,0.25))',
            flexShrink: 0,
          }}
        />
      </div>
      <div className="header-actions">
        <select className="lang-select" defaultValue="FR" title="Langue">
          {LANGUAGES.map((l) => (
            <option key={l} value={l} style={{ background: 'var(--bg-panel)' }}>{l}</option>
          ))}
        </select>
        <button
          className="header-icon-btn"
          onClick={() => toast.info('Notifications : 0 non lues')}
          aria-label="notifications"
          title="Notifications"
        >
          <Bell size={16} />
        </button>
        {!isAuthed && !loading && (
          <button
            className="btn-google"
            onClick={login}
            data-testid="btn-google-login"
          >
            <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#ffffff" d="M21.35 11.1h-9.18v2.92h5.27c-.24 1.34-1.61 3.93-5.27 3.93-3.17 0-5.76-2.62-5.76-5.85s2.59-5.85 5.76-5.85c1.81 0 3.02.77 3.71 1.43l2.53-2.43C16.76 3.55 14.7 2.6 12.17 2.6 6.95 2.6 2.72 6.83 2.72 12.05s4.23 9.45 9.45 9.45c5.46 0 9.07-3.84 9.07-9.24 0-.62-.07-1.1-.16-1.16z"/></svg>
            Connexion Google
          </button>
        )}
        {isAuthed && (
          <div className="user-chip" data-testid="user-chip">
            {user.picture && <img src={user.picture} alt={user.name} className="user-avatar" />}
            <div className="user-info">
              <span className="user-name">{user.name}</span>
              <span className="user-email">{user.email}</span>
            </div>
            <button
              className="header-icon-btn"
              onClick={async () => { await logout(); toast.success('Déconnecté'); }}
              title="Se déconnecter"
              data-testid="btn-logout"
            >
              <LogOut size={14} />
            </button>
          </div>
        )}
        {!isAuthed && (
          <button
            className="header-account-btn"
            onClick={login}
            title="Mon compte"
            data-testid="btn-account"
          >
            <User size={14} />
            <span>Compte</span>
          </button>
        )}
      </div>
    </header>
  );
}
